import { render, staticRenderFns } from "./textualResearch.vue?vue&type=template&id=e15789f8"
import script from "./textualResearch.vue?vue&type=script&lang=js"
export * from "./textualResearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports